import queryString from 'query-string';

export const getQueryParams = <T = Record<string, string>>() =>
  (queryString.parse(window.location.search) as unknown) as T;
